/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Sample_Coach_FullInputs */

const en_features_sample_coach_full = /** @type {(inputs: Features_Sample_Coach_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kate Morgan`)
};

const pl_features_sample_coach_full = /** @type {(inputs: Features_Sample_Coach_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasia Wrona`)
};

/**
* | output |
* | --- |
* | "Kate Morgan" |
*
* @param {Features_Sample_Coach_FullInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_sample_coach_full = /** @type {((inputs?: Features_Sample_Coach_FullInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Sample_Coach_FullInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_sample_coach_full(inputs)
	return en_features_sample_coach_full(inputs)
});